import React, { useState, useRef, useEffect, useContext } from 'react';
import { ButtonIconRound } from '.';
import { TimeContext } from '../../context/time';

const TimeRangeButton = () => {
  const timeContext = useContext(TimeContext);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [showPopOver, setShowPopOver] = useState(false);

  const handleClickOutside = (event: Event) => {
    const current = wrapperRef.current;
    if (current && wrapperRef.current && !current.contains(event.target as HTMLDivElement)) {
      setShowPopOver(false);
    }
  };

  // Add an event listener and clean it up on unmount
  // See React useEffect docs for more info.
  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  });

  return (
    <div className="relative" ref={wrapperRef}>
      <ButtonIconRound
        name="calendar"
        iconSize={30}
        iconViewBox={30}
        onClick={() => setShowPopOver(true)}
        className="mr2"
      />

      {showPopOver && (
        <div className="bg-white shadow-1 absolute top-0 left-0 br2 blue hover-navy tc f6 w4 z-max">
          <button
            className="pointer blue hover-navy w-100 pv2 ph3 bb b--light-gray"
            onClick={() => {
              timeContext.setTimeScale('week');
              setShowPopOver(false);
            }}
            disabled={timeContext.timeScale === 'week'}
          >
            Week
          </button>
          <button
            className="pointer blue hover-navy w-100 pv2 ph3 bb b--light-gray"
            onClick={() => {
              timeContext.setTimeScale('month');
              setShowPopOver(false);
            }}
            disabled={timeContext.timeScale === 'month'}
          >
            Month
          </button>
          <button
            className="pointer blue hover-navy w-100 pv2 ph3"
            onClick={() => {
              timeContext.setTimeScale('year');
              setShowPopOver(false);
            }}
            disabled={timeContext.timeScale === 'year'}
          >
            Year
          </button>
        </div>
      )}
    </div>
  );
};

export default TimeRangeButton;
